import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Studio from "./pages/Studio";
import Dashboard from "./pages/Dashboard";
import PaymentStatus from "./pages/PaymentStatus";
import Login from "./pages/Login";
import { UsageBar } from "./components/UsageBar";
import AuthCallback from "./components/AuthCallback";
import Splash from "./components/Splash";
import { Toaster } from "./components/ui/sonner";

// popup landed without a session (user cancelled): just close it
function PopupClose() {
  React.useEffect(() => { if (window.opener) window.close(); else window.location.replace("/login"); }, []);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (<>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth-popup" element={<PopupClose />} />
      <Route path="/studio" element={<Studio />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/payment/success" element={<PaymentStatus mode="success" />} />
      <Route path="/payment/cancel" element={<PaymentStatus mode="cancel" />} />
    </Routes>
    {location.pathname !== "/login" && <UsageBar key={location.pathname} />}
  </>);
}

function App() {
  const [showSplash, setShowSplash] = React.useState(() => {
    try { return !sessionStorage.getItem("trimo_splash"); } catch (e) { return true; }
  });
  const hide = React.useCallback(() => {
    try { sessionStorage.setItem("trimo_splash", "1"); } catch (e) {}
    setShowSplash(false);
  }, []);
  return (
    <div className="App">
      {showSplash && <Splash onDone={hide} />}
      <LanguageProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-center" theme="dark" richColors />
          </AuthProvider>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
